module.exports = __webpack_public_path__ + "img/s07-bg1.f7bd3a5f.jpg";